import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ModuloResponse, ModuloRequest, SearchModuloRequest } from "app/shared/models/ei-models";
import { environment } from "environments/environment";
import { Observable } from "rxjs";
import { BaseService } from "../../core";

@Injectable({
    providedIn: 'root'
})
export class ModuloService extends BaseService {
    private controllerEndpoint = environment.urlEdducaImobApi.concat('api/Modulo/');

    constructor(private httpClient: HttpClient) {
        super();
    }

    obterPorId(id: number): Observable<ModuloResponse> {
        return this.httpClient.get<ModuloResponse>(
            this.controllerEndpoint.concat('Obter/', id.toString()),
            { headers: this.getHeader(true) }
        );
    }

    listarTodos(): Observable<ModuloResponse[]> {
        return this.httpClient.get<ModuloResponse[]>(
            this.controllerEndpoint.concat('ListarTodos'),
            { headers: this.getHeader(true) }
        );
    }

    listarModulos(filter: SearchModuloRequest, loader = true): Observable<Array<ModuloResponse>> {
        return this.httpClient.post<Array<ModuloResponse>>
            (this.controllerEndpoint.concat('ListarModulos'), filter, { headers: this.getHeader(loader) });
    }

    criar(payload: ModuloRequest): Observable<void> {
        return this.httpClient.post<void>(
            this.controllerEndpoint.concat('Criar'),
            payload,
            { headers: this.getHeader(true) }
        );
    }

    atualizar(payload: ModuloRequest): Observable<void> {
        return this.httpClient.put<void>(
            this.controllerEndpoint.concat('Atualizar/', payload.id.toString()),
            payload,
            { headers: this.getHeader(true) }
        );
    }

    remover(id: number): Observable<void> {
        return this.httpClient.delete<void>(
            this.controllerEndpoint.concat('Remover/', id.toString()),
            { headers: this.getHeader(true) }
        );
    }
}